<a class="nav-link dropdown-toggle" (click)="false" href data-toggle="dropdown" dropdownToggle>
  {{ dropDownLabel }} <span class="caret"></span>
</a>
<ul *dropdownMenu class="dropdown-menu animated fadeIn" role="menu">
  <li role="menuitem">
    <a class="dropdown-item" (click)="showSearchParzellenWidget()" translate>
      <span class="esri-icon-locate">&nbsp;</span>HEADER_PANEL.SEARCH_PARZELLEN_SBB</a>
  </li>
  <li role="menuitem">
    <a class="dropdown-item" (click)="showSearchParzellenCHWidget()" translate>
      <span class="esri-icon-locate">&nbsp;</span>HEADER_PANEL.SEARCH_PARZELLEN_CH</a>
  </li>
  <li role="menuitem">
    <a class="dropdown-item" (click)="showSearchHektometerWidget()" translate>
      <span class="esri-icon-locate">&nbsp;</span>HEADER_PANEL.SEARCH_HEKTOMETER</a>
  </li>
</ul>
